import { AnchorHTMLAttributes, forwardRef } from 'react';

import { base, browser } from 'lib';

type IProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

const Link = forwardRef<HTMLAnchorElement, IProps>((props, ref) => {
  const { href, target, onClick } = props;

  const handleClick = (e) => {
    if (href === '#') {
      e.preventDefault();
    }

    if (base.isPcClientPage() && browser.memeClient && href && href !== '#') {
      e.preventDefault();
      base.redirectUrl(href, !!target);
    }
    onClick && onClick(e);
  };

  return <a ref={ref} {...props} onClick={handleClick}></a>;
});

export default Link;
